<template>
  <div class="wrap">
    <div class="warp_oldson">
      <p class="backpage">
        <i class="el-icon-back" @click="BackPage"></i>
      </p>
      <h4 class="titile">设置密码</h4>
      <div class="content">
        <!-- <input
          class="input"
          type="text"
          placeholder="请输入您的密码"
          v-model="shuru.password"
          @change="FirstInput"
        />-->
        <el-input
          @change="FirstInput"
          class="input"
          placeholder="请输入您的密码"
          v-model="shuru.password"
          show-password
          maxlength="25"
          minlength="8"
        ></el-input>
        <span class="promp">{{ cuowuspan.Verification }}</span>
        <div class="three_origin">
          <div>
            <!-- <span :class="{ curr: /\d/.test(shuru.pass) }">●</span> -->
            <div class="origin">
              <span :class="{ curral: /\d/.test(shuru.password) }"></span
              >密码中包含数字
            </div>
            <div class="origin">
              <span :class="{ curral: /[a-zA-Z]/g.test(shuru.password) }"></span
              >密码中包含字母
            </div>
          </div>
          <div class="origin">
            <span
              :class="{
                curral: /^[0-9a-zA-Z_]{8,25}$/.test(shuru.password),
              }"
            ></span
            >8-25位密码且没有特殊字符
          </div>
        </div>
        <el-input
          @change="SecondInput"
          class="input isinput"
          placeholder="请确认您的密码"
          v-model="shuru.password_two"
          show-password
          maxlength="25"
          minlength="8"
        ></el-input>
        <span class="promp">{{ cuowuspan.two_Verification }}</span>
      </div>
      <div class="footer_btn">
        <button
          :class="this.NextStep == true ? 'next_button' : 'next_button_son'"
          @click="registered"
        >
          下一步
        </button>
      </div>
      <!-- 温馨提示 -->
      <div :class="this.nextHidden == false ? 'prompt' : 'prompt_new'">
        <div class="prompt_oldson">
          <p class="backpage">
            <i class="el-icon-back" @click="backPassword"></i>
            <span class="titile_prompt">温馨提示</span>
          </p>
          <div class="TitlePromptContent">
            <section class="container">
              <dl>
                <dt>
                  <font>●</font>
                  新人注册成功则免费赠送
                  <strong>2</strong>海星点。
                  <!-- 次日起即可参与【<strong>答题赠点</strong>】活动,答对则可免费领取
                  <strong>6</strong>海星点，每个用户仅限一次,详情见【
                  <strong>个人中心</strong>】—【 <strong>领赠点</strong>】。-->
                </dt>
                <dt class="one">
                  <font>●</font>
                  线路情况：3070/3090/4090 支持rtx光追和dlss2.0。 
                </dt>
                <dt class="one">
                  <font>●</font> 计费规则：<strong>3070和高配线路3090 2海星点/小时 4090线路 3海星点/小时</strong>。
                </dt>
                <dt class="one">
                  <font>●</font> 用户可申请实名认证,
                  <strong>实名认证成功可获得6海星点赠点奖励</strong>
                  (前往官网或下载海星云安卓版进行实名认证，iOS版敬请期待)。
                </dt>

                <dt class="one">
                  <font>●</font>
                  智能排队，VIP等级高的优先排队，VIP等级说明详见官网个人中心或手机客户端。
                </dt>

                <dt class="one">
                  <font>●</font>
                  海星云平台禁止使用外挂、进行比特币等数字货币挖矿等违约、违规、违法、违反公序良俗、侵犯屯云科技或他人权益的行为，一经发现，即刻封号，敬请悉知。
                </dt>
              </dl>
            </section>
          </div>
          <div class="footer_btn">
            <button class="next_button nexB_Width" @click="nex_Invitation">
              下一步
            </button>
          </div>
          <div
            :class="
              this.IChidden == true ? 'InvitationCode' : 'InvitationCode_son'
            "
          >
            <p class="backpage">
              <i class="el-icon-back Bapi" @click="Backprompt"></i>
              <i
                class="el-dialog__close el-icon el-icon-close"
                @click="ShutDown"
              ></i>
            </p>
            <h4 class="titile title1">填写邀请码</h4>
            <div class="InvCodEight">
              <el-input
                :class="PluckingWool != '' ? 'rt-input' : 'rt_input_a'"
                type="text"
                placeholder="填写8位邀请码(选填)"
                @change="JudgmentInCo"
                v-model="InvitationCode"
                :disabled="
                  PluckingWool == '' ? false : PluckingWool != '' ? true : false
                "
              ></el-input>
              <span class="promp">{{ InvitationCodeErroe }}</span>
            </div>
            <div class="footer_btn">
              <button class="next_button" @click="FinalRegistration">
                注册
              </button>
              <button
                class="next_button next_button1"
                @click="JudgmentInCoJump"
                v-show="
                  PluckingWool == '' ? true : PluckingWool != '' ? false : true
                "
              >
                注册（跳过邀请码）
              </button>
            </div>
            <div class="ITC_footer">
              <div class="ITCF_img">
                <img src="../../static/bp.png" alt />
              </div>
              <span>
                受
                <em>vip0</em>及其以上用户邀请的新人
              </span>
              <span>
                注册首充
                <em>50</em>元,可获得 <em>25</em>点奖励
              </span>
              <span>
                受
                <em>vip3</em>及其以上用户邀请的新人
              </span>
              <span>
                注册首冲
                <em>200</em>元,可获得 <em>100</em>点奖励
              </span>
              <div class="jsq">(本活动最终解释权归海星云官方所有)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MobilePhoneNumberRegistration',
  components: {},
  props: {
    yphone: String,
    yVerification: String,
    yticket: String,
    yrandstr: String
  },
  data () {
    return {
    // 返回上一层级
      clickBack: false,

      // 输入的数据
      shuru: {
        password: '',
        password_two: '',
        FinalPassword: ''
      },
      // 错误的提示信息
      cuowuspan: {
        Verification: '',
        two_Verification: ''
      },
      // 是否可以下一步
      NextStep: false,

      // 下一步 温馨提示框
      nextHidden: false,

      // 下一步 是否有邀请码
      IChidden: false,

      // 邀请码
      InvitationCode: '',
      // 邀请码错误信息提示
      InvitationCodeErroe: '',
      // 后台返回数据,你的邀请码是否正确
      SpecialCode: null,
      // token
      tokenen: '',
      // 薅羊毛部分
      PluckingWool: ''
    }
  },
  mounted () {
    if (this.$route.query.invtecode != undefined) {
      if (this.$route.query.invtecode != '' && this.$route.query.invtecode.length == 8) {
        this.PluckingWool = this.$route.query.invtecode
        this.InvitationCode = this.PluckingWool
      }
    }
  },
  methods: {
    // 返回注册获取手机验证框
    BackPage () {
      this.$emit('func', this.clickBack)
    },
    // 设置密码 第一个密码填写框
    FirstInput () {
      if (this.shuru.password == '') {
        this.cuowuspan.Verification = '密码不能为空'
      } else if (this.shuru.password) {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
        if (reg.test(this.shuru.password)) {
          if (this.shuru.password == this.shuru.password_two || this.shuru.password_two == '') {
            this.cuowuspan.Verification = ''
            this.cuowuspan.two_Verification = ''
          } else if (this.shuru.password == this.shuru.password_two || this.shuru.password_two != '') {
            this.cuowuspan.Verification = '两次输入密码不一致'
          }
        } else {
          this.cuowuspan.Verification = '密码格式有误'
        }
      }
    },
    // 设置密码 ,第二个密码填写框
    SecondInput () {
      if (this.shuru.password_two != this.shuru.password) {
        if (this.shuru.password == '') {
          this.cuowuspan.two_Verification = ''
        } else if (this.shuru.password_two != this.shuru.password || this.shuru.password != '') {
          this.cuowuspan.two_Verification = '两次输入密码不一致'
        }
      } else if (this.shuru.password_two == this.shuru.password) {
        this.cuowuspan.two_Verification = ''
      }
    },
    // 密码验证通过后,弹出温馨提示框
    registered () {
      // console.log(this.yphone,this.yVerification)
      if (this.NextStep == true) {
        // console.log('弹出温馨提示')
        this.nextHidden = true
      } else if (this.NextStep != true) {
        console.log('请检查你的密码是否正确')
      }
    },
    // 温馨提示后,弹出邀请码框
    nex_Invitation () {
      this.IChidden = true
    },

    // 返回到设置密码框
    backPassword () {
      if (this.nextHidden == false) {

      } else if (this.nextHidden == true) {
        this.nextHidden = false
      }
    },
    // 返回到温馨提示
    Backprompt () {
      if (this.IChidden == false) {

      } else if (this.IChidden == true) {
        this.IChidden = false
      }
    },
    // 判断邀请码
    JudgmentInCo () {
      if (this.InvitationCode.length == 8) {
        this.http.yzyaoqingma(this.InvitationCode)
          .then(res => {
            this.SpecialCode = res.data.message
            if (res.data.message == 'false') {
              this.InvitationCodeErroe = res.data.message2
            } else if (res.data.message == 'true') {
              this.InvitationCodeErroe = ''
            }
          })
      } else if (this.InvitationCode.length != 8 && this.InvitationCode.length != 0) {
        this.InvitationCodeErroe = '该邀请码不存在'
      } else if (this.InvitationCode.length == 0) {
        this.InvitationCodeErroe = ''
      }
    },

    // 最终的注册请求
    FinalRegistration () {
      if (this.PluckingWool != '') {
        this.http.yzyaoqingma(this.PluckingWool)
          .then(res => {
            if (res.data.message == 'false') {
              this.InvitationCodeErroe = res.data.message2
              console.log(typeof res.data.message)
            } else if (res.data.message == 'true') {
              this.$message({
                message: '您的邀请码无误!',
                type: 'success'
              })
              this.http
                .hxy_registered(this.yphone, this.FinalPassword, this.yVerification, this.PluckingWool, this.yticket, this.yrandstr)
                .then(res => {
                  console.log(res)
                  if (res.data.code == 200) {
                    this.http
                      .denglu(this.yphone, this.FinalPassword)
                      .then(res => {
                        console.log(res)
                        if (res.status == 200 && res.data.code === 200) {
                          this.tokenen = res.data.data.token
                          this.$cookieStore.setCookie(
                            'user_sess',
                            this.tokenen,
                            2590000
                          )
                          this.$message({
                            message: '登录成功！',
                            type: 'success'
                          })
                          window.localStorage.setItem('state', 'logged')
                          if (this.flagflag == 1) {
                            window.location.reload()
                          } else {
                            this.$router.push({
                              path: './Center',
                              query: {value: 'nice'}
                            })
                          }
                        } else if (res.data.code === 404) {
                          this.$message.error('您未注册，请先注册！')
                        } else if (res.data.code === 401) {
                          this.$message.error('密码错误，请重试！')
                        } else {
                          this.$message.error(res.data.message)
                        }
                      })
                      .catch(err => {
                        console.log('err: ', JSON.stringify(err))
                      })
                  } else if (res.data.code != 200) {
                    this.$message.error('验证码错误或验证已超时,请重试!')
                  }
                })
            }
          })
      } else if (this.PluckingWool == '') {
        if (this.InvitationCode.length == 8) {
          this.http.yzyaoqingma(this.InvitationCode)
            .then(res => {
              if (res.data.message == 'false') {
                this.InvitationCodeErroe = res.data.message2
                console.log(typeof res.data.message)
              } else if (res.data.message == 'true') {
                this.$message({
                  message: '您的邀请码无误!',
                  type: 'success'
                })
                this.http
                  .hxy_registered(this.yphone, this.FinalPassword, this.yVerification, this.InvitationCode, this.yticket, this.yrandstr)
                  .then(res => {
                    console.log(res)
                    if (res.data.code == 200) {
                      this.http
                        .denglu(this.yphone, this.FinalPassword)
                        .then(res => {
                          console.log(res)
                          if (res.status == 200 && res.data.code === 200) {
                            this.tokenen = res.data.data.token
                            this.$cookieStore.setCookie(
                              'user_sess',
                              this.tokenen,
                              2590000
                            )
                            this.$message({
                              message: '登录成功！',
                              type: 'success'
                            })
                            window.localStorage.setItem('state', 'logged')
                            if (this.flagflag == 1) {
                              window.location.reload()
                            } else {
                              this.$router.push({
                                path: './Center',
                                query: {value: 'nice'}
                              })
                            }
                          } else if (res.data.code === 404) {
                            this.$message.error('您未注册，请先注册！')
                          } else if (res.data.code === 401) {
                            this.$message.error('密码错误，请重试！')
                          } else {
                            this.$message.error(res.data.message)
                          }
                        })
                        .catch(err => {
                          console.log('err: ', JSON.stringify(err))
                        })
                    } else if (res.data.code != 200) {
                      this.$message.error('验证码错误或验证已超时,请重试!')
                    }
                  })
              }
            })
        } else if (this.InvitationCode.length != 8 && this.InvitationCode.length != 0) {
          this.InvitationCodeErroe = '该邀请码不存在'
        } else if (this.InvitationCode.length == 0) {
          this.InvitationCodeErroe = ''
          if (this.InvitationCode === '') {
            this.http
              .hxy_registered(this.yphone, this.FinalPassword, this.yVerification, this.InvitationCode, this.yticket, this.yrandstr)
              .then(res => {
                console.log(res)
                if (res.data.code == 200) {
                  this.http
                    .denglu(this.yphone, this.FinalPassword)
                    .then(res => {
                      console.log(res)
                      if (res.status == 200 && res.data.code === 200) {
                        this.tokenen = res.data.data.token
                        this.$cookieStore.setCookie(
                          'user_sess',
                          this.tokenen,
                          2590000
                        )
                        this.$message({
                          message: '登录成功！',
                          type: 'success'
                        })
                        window.localStorage.setItem('state', 'logged')
                        if (this.flagflag == 1) {
                          window.location.reload()
                        } else {
                          this.$router.push({
                            path: './Center',
                            query: {value: 'nice'}
                          })
                        }
                      } else if (res.data.code === 404) {
                        this.$message.error('您未注册，请先注册！')
                      } else if (res.data.code === 401) {
                        this.$message.error('密码错误，请重试！')
                      } else {
                        this.$message.error(res.data.message)
                      }
                    })
                    .catch(err => {
                      console.log('err: ', JSON.stringify(err))
                    })
                } else if (res.data.code != 200) {
                  this.$message.error('验证码错误或验证已超时,请重试!')
                }
              })
          }
        }
      }
    },
    JudgmentInCoJump () {
      this.http
        .hxy_registered(this.yphone, this.FinalPassword, this.yVerification, '', this.yticket, this.yrandstr)
        .then(res => {
          if (res.data.code == 200) {
            this.http
              .denglu(this.yphone, this.FinalPassword)
              .then(res => {
                console.log(res)
                if (res.status == 200 && res.data.code === 200) {
                  this.tokenen = res.data.data.token
                  this.$cookieStore.setCookie(
                    'user_sess',
                    this.tokenen,
                    2590000
                  )
                  this.$message({
                    message: '登录成功！',
                    type: 'success'
                  })
                  window.localStorage.setItem('state', 'logged')
                  if (this.flagflag == 1) {
                    window.location.reload()
                  } else {
                    this.$router.push({
                      path: './Center',
                      query: {value: 'nice'}
                    })
                  }
                } else if (res.data.code === 404) {
                  this.$message.error('您未注册，请先注册！')
                } else if (res.data.code === 401) {
                  this.$message.error('密码错误，请重试！')
                } else {
                  this.$message.error(res.data.message)
                }
              })
              .catch(err => {
                console.log('err: ', JSON.stringify(err))
              })
          } else if (res.data.code != 200) {
            this.$message.error('验证码错误或验证已超时,请重试!')
          }
        })
    },
    ShutDown () {
      // alert('哈撒尅')

      this.$store.commit('addGlobalLogin', true)
      this.$emit('func', this.clickBack)
      this.shuru.password = ''
      this.shuru.password_two = ''
      setTimeout(() => {
        this.$store.commit('addGlobalLogin', null)
      }, 100)
    }
  },
  watch: {
    'shuru.password': function () {
      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
      if (this.shuru.password == this.shuru.password_two && reg.test(this.shuru.password)) {
        this.NextStep = true
        this.FinalPassword = this.shuru.password
        this.cuowuspan.Verification = ''
        this.cuowuspan.two_Verification = ''
      } else if (this.shuru.password != this.shuru.password_two) {
        this.NextStep = false
      }
    },
    'shuru.password_two': function () {
      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
      if (this.shuru.password == this.shuru.password_two && reg.test(this.shuru.password)) {
        this.NextStep = true
        this.FinalPassword = this.shuru.password
        this.cuowuspan.Verification = ''
        this.cuowuspan.two_Verification = ''
      } else if (this.shuru.password != this.shuru.password_two) {
        this.NextStep = false
      }
    }
  },
  computed: {

  }
}
</script>
<style ange="sass" scoped>
.rt-input /deep/ .el-input__inner {
  color: #bfbfbf80 !important;
  display: block;
  margin: 0 auto;
  width: 237px;
  border-style: none;
  border-bottom: 1px solid #ffffff5c !important;
  outline: none;
  text-indent: 15px;
  font-size: 12px !important;
  caret-color: #f4c91d;
  background-color: transparent;
  height: 40px;
  transition-duration: 0.3s;
}
.rt_input_a /deep/ .el-input__inner {
  color: #fff !important;
  display: block;
  margin: 0 auto;
  width: 237px;
  border-style: none;
  border-bottom: 1px solid #ffffff5c !important;
  outline: none;
  text-indent: 15px;
  font-size: 12px !important;
  caret-color: #f4c91d;
  background-color: transparent;
  height: 40px;
  transition-duration: 0.3s;
}
.rt-input:focus {
  border-bottom: 1px solid white !important;
}
.rt_input_a:focus {
  border-bottom: 1px solid white !important;
}
/* .input_zhuce {
  display: block;
  margin: 0 auto;
  width: 237px;
  border-style: none;
  border-bottom: 1px solid #ffffff5c !important;
  outline: none;
  text-indent: 15px;
  font-size: 12px !important;
  caret-color: #f4c91d;
  background-color: transparent;
  height: 40px;
  color: white;
  transition-duration: 0.3s;
}
.input_zhuce:focus {
  border-bottom: 1px solid white !important;
} */
.wrap {
  position: absolute;
  width: 100% !important;
  height: 100%;
  left: 0;
  top: 0;
  /* border: 1px solid red;
  box-sizing: border-box; */
  background-color: #182133;
  border-radius: 12px;
  padding: 20px 20px;
}
.backpage {
  width: 100%;
  height: 25px;
}
.backpage i {
  display: block;
  /* float: left; */
  color: white;
  height: 100%;
  text-align: center;
  width: 50px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 18px;
  line-height: 25px;
}
.backpage i:hover {
  background-color: #6767676e;
}
.titile {
  text-align: center;
  margin-top: 35px;
}
.titile_prompt {
  display: block;
  text-align: center;
  width: 100%;
  font-weight: 600;
  font-size: 20px;
  color: white;
  margin-top: -24px;
}
.content {
  margin-top: 50px;
}
.content .input {
  display: block !important;
  margin: 0 auto !important;
  width: 237px !important;
  border-style: none !important;
  /* border-bottom: 1px solid #ffffff5c !important; */
  font-size: 12px !important;
  caret-color: #f4c91d !important;
  background-color: transparent !important;
  height: 40px;
  color: white;
}
.input::-webkit-input-placeholder {
  border-bottom: 1px solid white;
}

.input:focus {
}
.content div {
  width: 237px;
}
.three_origin {
  height: 75px;
  margin: 0 auto;
}
.three_origin div {
  height: 35px;
  color: white;
  font-size: 10px;
  float: left;
}
.three_origin div {
  display: flex;
  align-items: center;
}
.origin span {
  display: inline-block !important;
  border-radius: 50px;
  background-color: red;
  width: 12px;
  height: 12px;
  margin-right: 5px !important;
}
.isinput {
  margin-top: 20px !important;
}
.footer_btn {
  width: 100%;
  margin-top: 5px;
}
.next_button1 {
  margin-top: 5px !important;
}
.next_button {
  width: 200px;
  display: block;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 0 auto;
  background-color: #8f8f8f;
  color: #ffffff8a;
  border: none;
  border-radius: 6px;
  background: linear-gradient(to right, #fff282, #f4c91d);
  color: black;
  transition-duration: 0.6s;
}
.nexB_Width {
  width: 100% !important;
}
.next_button_son {
  width: 237px;
  display: block;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 0 auto;
  background-color: #8f8f8f;
  color: #ffffff8a;
  border: none;
  border-radius: 6px;
  transition-duration: 0.6s;
}
.promp {
  display: block;
  font-size: 10px;
  color: #f56c6c;
  margin: 0 auto;
  width: 237px;
  height: 12px;
  margin-bottom: 10px;
}
.curral {
  background-color: greenyellow !important;
  transition-duration: 0.6s;
}
.warp_oldson {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1000;
}
.prompt {
  position: absolute;
  left: 370px;
  top: 0;
  background-color: #182133;
  width: 100%;
  height: 100%;
}
.prompt_new {
  position: absolute;
  left: 0;
  top: 0;
  background-color: #182133;
  width: 100%;
  height: 100%;
}
.TitlePromptContent {
  width: 88%;
  height: 65%;
  border-radius: 5px;
  background-color: #222b42;
  margin: 25px auto;
  font-size: 12px;
  color: white;
  overflow-y: auto;
}
.prompt_oldson {
  position: relative;
  height: 100%;
}
.InvitationCode {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #182133;
}
.InvitationCode .title1 {
  text-align: center;
  margin-top: 0 !important;
}
.InvitationCode_son {
  position: absolute;
  left: 370px;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #182133;
}
.ITC_footer {
  width: 100%;
  margin: 5px auto 0;
  height: 200px;
  position: relative;
  line-height: normal;
  text-align: center;
}
.jsq {
  font-size: 12px;
  text-align: center;
}
.ITC_footer span {
  display: block;
  color: white;
  font-size: 12px;
  width: 210px;
  margin: 0 auto;
}
.ITC_footer span em {
  font-size: 14px;
  font-weight: 900;
  color: #ffcc00;
  font-style: normal;
}
.ITCF_img {
  width: 100%;
}
.ITCF_img img {
  width: 100%;
  height: 100%;
}
.InvCodEight {
  margin: 0 auto;
  height: 50px;
  margin-top: 5px;
  position: relative;
}
.container {
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 1);
  font-family: NotoSansHans-Regular, NotoSansHans;
  background-color: #243457;
  width: 100%;
  padding: 15px 12px 25px 12px;
}

strong {
  color: #ffcc00;
  font-weight: bold;
  font-size: 14px;
}
dl {
  font-size: 12px;
  margin: 0 auto;
  /* font-weight: 400; */
}

dl dt,
dl dd {
  margin-left: 0;
}

font {
  color: #fff;
  font-size: 14px;
}
.one {
  margin-top: 20px;
}
.skip {
  display: inline-block;
  float: right();
  width: 56px;
  height: 25px;
  cursor: pointer;
  text-align: center;
  border-radius: 3px;
  position: absolute;
  top: 7px;
  right: 36px;
  color: white !important;
}
.skip:hover {
  background-color: #6767676e;
}
.Bapi {
  float: left;
}
.backpage i:nth-child(2) {
  float: right;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  line-height: 32px;
  text-align: center;
  padding: 0;
  position: relative;
  z-index: 20;
}
</style>



// WEBPACK FOOTER //
// src/base/OW_PhoneNumberRegistration.vue